import axios from 'axios'

const request = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

export default {
  getBusList (params) {
    return request.get(`/buses`, { params })
  },
  getRouteList (params) {
    return request.get(`/routes`, { params })
  }
}
